import { Colors, Icon, Text } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import { IconCircle } from './surfaces';

import objectivesHeroArrow from '@/assets/illustrations/objectivesHeroArrow.png';
import { GLASS_SURFACE, OVERVIEW_HERO_TITLE } from '@/components/objectives/objectiveStyles';

interface ObjectivesHeaderProps {
    /** The company's strategic vision; the quote card is hidden when it is empty. */
    strategicVision?: string;
}

export default function ObjectivesHeader({ strategicVision }: ObjectivesHeaderProps) {
    const { t } = useTranslation();

    return (
        <div className={'obj-hero'}>
            <div
                className={`obj-hero-card ${GLASS_SURFACE}`}
                data-testid={'objectives-header'}
            >
                <div className={'flex items-center gap-3'}>
                    <IconCircle className={'bg-obj-tint obj-header-icon-circle'}>
                        <Icon
                            name={'cryptocompany-target'}
                            size={36}
                            colorClassName={'text-obj-turquoise'}
                            strokeWidth={1.8}
                            className={'obj-header-icon-svg'}
                        />
                    </IconCircle>

                    <div>
                        <h1 className={`${OVERVIEW_HERO_TITLE} mb-1`}>{t('objectives.title')}</h1>

                        <Text color={Colors.NAVY}>{t('objectives.subtitle')}</Text>
                    </div>
                </div>
            </div>

            {/* The arrow points from the header card to the quote: with no vision to quote it
                would point at nothing, so it lives and dies with the card it leads to. */}
            {strategicVision && (
                <>
                    <img
                        src={objectivesHeroArrow}
                        alt={''}
                        aria-hidden
                        width={346}
                        height={159}
                        className={'obj-hero-arrow pointer-events-none'}
                    />

                    <div
                        className={`obj-hero-quote ${GLASS_SURFACE}`}
                        data-testid={'objectives-vision-quote'}
                    >
                        <span
                            aria-hidden
                            className={'obj-hero-mark'}
                        >
                            “
                        </span>

                        <div
                            className={
                                'obj-hero-quote-inner flex items-center justify-center rounded-lg bg-white/90'
                            }
                        >
                            <p
                                className={
                                    'obj-hero-quote-text text-navy font-handwriting text-center'
                                }
                            >
                                {strategicVision}
                            </p>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
